export default __webpack_public_path__ + "5d52260ccb8f313aa3eb8b8be94881c4.png";